export class ToolReturnTypeEnum {
    static LINE = "LINE";
    static TICKET = "TICKET";
    static MAINTENANCE = "MAINTENANCE";
    static STRAIN = "STRAIN";
}
